/** Client-side download helper for server-generated property report PDFs. */

export interface PropertyReportPeriod {
  month: number;
  year: number;
}

export type PropertyReportExportResult =
  | { ok: true; filename: string }
  | { ok: false; reason: 'error'; message?: string };

function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

function buildFilename(propertyName: string | undefined, year: number, month: number): string {
  const safeName =
    (propertyName || 'property').replace(/[^a-zA-Z0-9-_]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '') ||
    'property';
  return `${safeName}-report-${year}-${String(month).padStart(2, '0')}.pdf`;
}

export async function exportPropertyConsolidatedReport(
  propertyId: string,
  month: number,
  year: number,
  downloadPdf: (id: string, month: number, year: number) => Promise<Blob>,
  propertyName?: string,
): Promise<PropertyReportExportResult> {
  try {
    const blob = await downloadPdf(propertyId, month, year);
    const filename = buildFilename(propertyName, year, month);
    triggerBlobDownload(blob, filename);
    return { ok: true, filename };
  } catch (err: any) {
    return {
      ok: false,
      reason: 'error',
      message: err?.message || 'Could not download the property report.',
    };
  }
}
